/**
 * TrackSubcribe
 * 
 * @Author: Focci
 * @Date: 2023-08-17 14:35:14
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-17 14:35:14
 */

import PropTypes from 'prop-types'
import useFetch from '@hook/useFetch'
import { useTranslations } from 'next-intl'
import TrackTitle from '../TrackTitle'
import TrackSkeletion from '../TrackSkeletion'
import TrackForm from './TrackForm'

export default function TrackSubcribe({
  onSubmit = () => {},
  property = {}
}) {
  const th = useTranslations('house')
  const { data, isLoading } = useFetch('property-sub-distance')
  const { data: types, isLoading: typeLoading } = useFetch('property-track-user-type')

  if(isLoading || typeLoading) {
    return <TrackSkeletion />
  }
  
  return (
    <div>
      <TrackTitle label={th('claimProperty')} />
      <TrackForm
        data={data}
        types={types}
        property={property}
        onSuccess={onSubmit}
      />
    </div>
  )
}

TrackSubcribe.propTypes = {
  onSubmit: PropTypes.func,
  property: PropTypes.object,
}
